import type { FUSportsTeamCompetitor, FUSportsCompetition } from "fansunited-data-layer";

/**
 * Teams mapped to FUSportsTeamCompetitor type with additional styling
 */
export const COMPETITORS: Record<string, Partial<FUSportsTeamCompetitor>> = {
    // AFC Bournemouth
    "123": {
        id: "123",
        nickname: "The Cherries",
        threeLetterCode: "BOU",
        shortName: "Bournemouth",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#DA291C",
                secondaryColor: "#000000",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#DA291C",
                backgroundGradientToColor: "#000000",
            },
        },
    },
    // Arsenal
    "97": {
        id: "97",
        nickname: "The Gunners",
        threeLetterCode: "ARS",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#EF0107",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#EF0107",
                backgroundGradientToColor: "#bf1621",
            },
        },
    },
    // Aston Villa
    "101": {
        id: "101",
        nickname: "The Villans",
        threeLetterCode: "AVL",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#670E36",
                secondaryColor: "#95BFE5",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#670E36",
                backgroundGradientToColor: "#95BFE5",
            },
        },
    },
    // Brentford
    "136": {
        id: "136",
        nickname: "The Bees",
        threeLetterCode: "BRE",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#E30613",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#E30613",
                backgroundGradientToColor: "#FBB800",
            },
        },
    },
    // Brighton & Hove Albion
    "134": {
        id: "134",
        nickname: "The Seagulls",
        shortName: "Brighton",
        threeLetterCode: "BHA",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#0057B8",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#0057B8",
                backgroundGradientToColor: "#005DAA",
            },
        },
    },
    // Burnley
    "118": {
        id: "118",
        nickname: "The Clarets",
        threeLetterCode: "BUR",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#6C1D45",
                secondaryColor: "#99D6EA",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#6C1D45",
                backgroundGradientToColor: "#99D6EA",
            },
        },
    },
    // Chelsea
    "82": {
        id: "82",
        nickname: "The Blues",
        threeLetterCode: "CHE",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#034694",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#034694",
                backgroundGradientToColor: "#0A1F8F",
            },
        },
    },
    // Crystal Palace
    "110": {
        id: "110",
        nickname: "The Eagles",
        threeLetterCode: "CRY",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#1B458F",
                secondaryColor: "#C4122E",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#1B458F",
                backgroundGradientToColor: "#C4122E",
            },
        },
    },
    // Everton
    "96": {
        id: "96",
        nickname: "The Toffees",
        threeLetterCode: "EVE",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#003399",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#003399",
                backgroundGradientToColor: "#001F5C",
            },
        },
    },
    // Fulham
    "98": {
        id: "98",
        nickname: "The Cottagers",
        threeLetterCode: "FUL",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#000000",
                secondaryColor: "#000000",
                textColor: "#ffffff",
                backgroundGradientFromColor: "#111",
                backgroundGradientToColor: "#333",
            },
        },
    },
    // Leeds United
    "83": {
        id: "83",
        nickname: "The Whites",
        shortName: "Leeds",
        threeLetterCode: "LEE",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#ffd600",
                secondaryColor: "#1D428A",
                textColor: "#000",
                backgroundGradientFromColor: "#ffd600",
                backgroundGradientToColor: "#595125",
            },
        },
    },
    // Liverpool
    "92": {
        id: "92",
        nickname: "The Reds",
        threeLetterCode: "LIV",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#C8102E",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#C8102E",
                backgroundGradientToColor: "#8B0000",
            },
        },
    },
    // Manchester City
    "104": {
        id: "104",
        nickname: "The Citizens",
        shortName: "Man City",
        threeLetterCode: "MCI",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#6CABDD",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#6CABDD",
                backgroundGradientToColor: "#1C2C5B",
            },
        },
    },
    // Manchester United
    "102": {
        id: "102",
        nickname: "The Red Devils",
        shortName: "Man United",
        threeLetterCode: "MUN",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#DA291C",
                secondaryColor: "#FBE122",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#DA291C",
                backgroundGradientToColor: "#8B0000",
            },
            fansUnitedContent: {
                listId: "2oNzO2Ts34BmDoMcsVzqKW",
            },
        },
    },
    // Newcastle United
    "103": {
        id: "103",
        nickname: "The Magpies",
        shortName: "Newcastle",
        threeLetterCode: "NEW",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#241F20",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#241F20",
                backgroundGradientToColor: "#000000",
            },
        },
    },
    // Nottingham Forest
    "133": {
        id: "133",
        nickname: "The Tricky Trees",
        shortName: "Nott'm Forest",
        threeLetterCode: "NFO",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#DD0000",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#DD0000",
                backgroundGradientToColor: "#8B0000",
            },
        },
    },
    // Sunderland
    "85": {
        id: "85",
        nickname: "The Black Cats",
        threeLetterCode: "SUN",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#EB172B",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#EB172B",
                backgroundGradientToColor: "#211E1F",
            },
        },
    },
    // Tottenham Hotspur
    "89": {
        id: "89",
        nickname: "Spurs",
        shortName: "Spurs",
        threeLetterCode: "TOT",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#132257",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#132257",
                backgroundGradientToColor: "#000000",
            },
        },
    },
    // West Ham United
    "94": {
        id: "94",
        nickname: "The Hammers",
        shortName: "West Ham",
        threeLetterCode: "WHU",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#7A263A",
                secondaryColor: "#1BB1E7",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#7A263A",
                backgroundGradientToColor: "#1BB1E7",
            },
        },
    },
    // Wolverhampton Wanderers
    "109": {
        id: "109",
        nickname: "Wolves",
        shortName: "Wolves",
        threeLetterCode: "WOL",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#FDB913",
                secondaryColor: "#231F20",
                textColor: "#231F20",
                backgroundGradientFromColor: "#FDB913",
                backgroundGradientToColor: "#b18318",
            },
        },
    },

    // ============================================
    // LA LIGA (Spain)
    // ============================================

    // Athletic Bilbao
    "198": {
        id: "198",
        nickname: "Los Leones",
        shortName: "Athletic",
        threeLetterCode: "ATH",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#EE2523",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#EE2523",
                backgroundGradientToColor: "#000000",
            },
        },
    },
    // Atletico Madrid
    "209": {
        id: "209",
        nickname: "Los Colchoneros",
        shortName: "Atleti",
        threeLetterCode: "ATM",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#CB3524",
                secondaryColor: "#272E61",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#CB3524",
                backgroundGradientToColor: "#272E61",
            },
        },
    },
    // Barcelona
    "205": {
        id: "205",
        nickname: "Blaugrana",
        shortName: "Barça",
        threeLetterCode: "BAR",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#A50044",
                secondaryColor: "#004D98",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#A50044",
                backgroundGradientToColor: "#004D98",
            },
        },
    },
    // Celta Vigo
    "212": {
        id: "212",
        nickname: "Os Celestes",
        shortName: "Celta",
        threeLetterCode: "CEL",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#8AC3EE",
                secondaryColor: "#FFFFFF",
                textColor: "#1A1A1A",
                backgroundGradientFromColor: "#8AC3EE",
                backgroundGradientToColor: "#2A5CAA",
            },
        },
    },
    // Deportivo Alaves
    "219": {
        id: "219",
        nickname: "El Glorioso",
        shortName: "Alavés",
        threeLetterCode: "ALA",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#0033A0",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#0033A0",
                backgroundGradientToColor: "#001F5C",
            },
        },
    },
    // Elche
    "213": {
        id: "213",
        nickname: "Los Franjiverdes",
        shortName: "Elche",
        threeLetterCode: "ELC",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#006633",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#006633",
                backgroundGradientToColor: "#003319",
            },
        },
    },
    // Espanyol
    "201": {
        id: "201",
        nickname: "Periquitos",
        shortName: "Espanyol",
        threeLetterCode: "ESP",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#007FC8",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#007FC8",
                backgroundGradientToColor: "#003366",
            },
        },
    },
    // Getafe
    "197": {
        id: "197",
        nickname: "Azulones",
        shortName: "Getafe",
        threeLetterCode: "GET",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#005999",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#005999",
                backgroundGradientToColor: "#003366",
            },
        },
    },
    // Girona
    "697": {
        id: "697",
        nickname: "Blanc-i-vermells",
        shortName: "Girona",
        threeLetterCode: "GIR",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#CD2534",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#CD2534",
                backgroundGradientToColor: "#8B0000",
            },
        },
    },
    // Levante
    "203": {
        id: "203",
        nickname: "Granotes",
        shortName: "Levante",
        threeLetterCode: "LEV",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#004A99",
                secondaryColor: "#E31E24",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#004A99",
                backgroundGradientToColor: "#E31E24",
            },
        },
    },
    // Mallorca
    "705": {
        id: "705",
        nickname: "Bermellones",
        shortName: "Mallorca",
        threeLetterCode: "MLL",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#E30613",
                secondaryColor: "#000000",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#E30613",
                backgroundGradientToColor: "#000000",
            },
        },
    },
    // Osasuna
    "218": {
        id: "218",
        nickname: "Los Rojillos",
        shortName: "Osasuna",
        threeLetterCode: "OSA",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#D91A21",
                secondaryColor: "#0A1E3C",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#D91A21",
                backgroundGradientToColor: "#0A1E3C",
            },
        },
    },
    // Rayo Vallecano
    "199": {
        id: "199",
        nickname: "Franjirrojos",
        shortName: "Rayo",
        threeLetterCode: "RAY",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#E53027",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#E53027",
                backgroundGradientToColor: "#B71C1C",
            },
        },
    },
    // Real Betis
    "215": {
        id: "215",
        nickname: "Verdiblancos",
        shortName: "Betis",
        threeLetterCode: "BET",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#00954C",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#00954C",
                backgroundGradientToColor: "#004D26",
            },
        },
    },
    // Real Madrid
    "204": {
        id: "204",
        nickname: "Los Blancos",
        shortName: "Real Madrid",
        threeLetterCode: "RMA",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#FFFFFF",
                secondaryColor: "#00529f",
                textColor: "#1A1A1A",
                backgroundGradientFromColor: "#FFFFFF",
                backgroundGradientToColor: "#00529f",
            },
        },
    },
    // Real Oviedo
    "712": {
        id: "712",
        nickname: "Carbayones",
        shortName: "Oviedo",
        threeLetterCode: "OVI",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#003DA5",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#003DA5",
                backgroundGradientToColor: "#001F5C",
            },
        },
    },
    // Real Sociedad
    "202": {
        id: "202",
        nickname: "Txuri-urdin",
        shortName: "Real Sociedad",
        threeLetterCode: "RSO",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#0067B1",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#0067B1",
                backgroundGradientToColor: "#003366",
            },
        },
    },
    // Sevilla
    "196": {
        id: "196",
        nickname: "Nervionenses",
        shortName: "Sevilla",
        threeLetterCode: "SEV",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#D40023",
                secondaryColor: "#FFFFFF",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#D40023",
                backgroundGradientToColor: "#8B0000",
            },
        },
    },
    // Valencia
    "210": {
        id: "210",
        nickname: "Los Ches",
        shortName: "Valencia",
        threeLetterCode: "VAL",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#EE3524",
                secondaryColor: "#000000",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#EE3524",
                backgroundGradientToColor: "#000000",
            },
        },
    },
    // Villarreal
    "211": {
        id: "211",
        nickname: "El Submarino Amarillo",
        shortName: "Villarreal",
        threeLetterCode: "VIL",
        type: "club",
        metadata: {
            branding: {
                primaryColor: "#FFE114",
                secondaryColor: "#005DAA",
                textColor: "#1A1A1A",
                backgroundGradientFromColor: "#FFE114",
                backgroundGradientToColor: "#005DAA",
            },
        },
    },

    // Default fallback
    default: {
        id: "default",
        name: "Team",
        nickname: "",
        threeLetterCode: "TBD",
        type: "club",
        assets: {
            logo: "",
        },
        metadata: {
            branding: {
                primaryColor: "#37003c",
                secondaryColor: "#00ff85",
                textColor: "#FFFFFF",
                backgroundGradientFromColor: "#37003c",
                backgroundGradientToColor: "#00ff85",
            },
        },
        providerRef: [
            {
                id: "default",
                provider: "sportal365",
            },
        ],
    },
};

/**
 * Sportal365 season ID for the current FIFA World Cup.
 * Used to detect whether a national team is a WC participant via
 * `apiTeam.activeSeasons.some(s => s.id === WORLD_CUP_SEASON_ID_SPORTAL365)`,
 * which lets us scope their squad stats to the tournament instead of falling
 * back to match-aggregated numbers.
 */
export const WORLD_CUP_SEASON_ID_SPORTAL365 = "4435455";

export const WORLD_CUP_GROUPS = [
    {
        group: "A",
        teams: [
            {
                sportal365_id: "1535",
                uuid: "4265eec4-3498-485a-8efc-bc408a98657f",
                fansUnitedTeamId: "fb:t:81535",
            },
            {
                sportal365_id: "1745",
                uuid: "87cf5b5d-aab9-4c6c-8f48-aa07b335d5f3",
                fansUnitedTeamId: "fb:t:81745",
            },
            {
                sportal365_id: "1465",
                uuid: "a199c991-ba2b-45f8-91fa-b5fd3e5d84f6",
                fansUnitedTeamId: "fb:t:81465",
            },
            {
                sportal365_id: "2348",
                uuid: "c4469e62-1076-413a-8692-1016defc570d",
                fansUnitedTeamId: "fb:t:82348",
            },
        ],
    },
    {
        group: "B",
        teams: [
            {
                sportal365_id: "2264",
                uuid: "28beace9-b1d1-4963-a2b0-6a7b1e7407dd",
                fansUnitedTeamId: "fb:t:82264",
            },
            {
                sportal365_id: "2231",
                uuid: "01a702d1-026a-4a15-9f0f-684a8a3c031c",
                fansUnitedTeamId: "fb:t:82231",
            },
            {
                sportal365_id: "1653",
                uuid: "d0a3387c-35ae-4b5c-98f9-3f70439e0614",
                fansUnitedTeamId: "fb:t:81653",
            },
            {
                sportal365_id: "1807",
                uuid: "22693106-9d85-41b1-b0dc-bc39a6c6c6f1",
                fansUnitedTeamId: "fb:t:81807",
            },
        ],
    },
    {
        group: "C",
        teams: [
            {
                sportal365_id: "2234",
                uuid: "252b7612-5c90-4263-93c5-0289922f00b0",
                fansUnitedTeamId: "fb:t:82234",
            },
            {
                sportal365_id: "1540",
                uuid: "c8928bbd-fe0a-40c3-b0b7-759a537a3333",
                fansUnitedTeamId: "fb:t:81540",
            },
            {
                sportal365_id: "1304",
                uuid: "e64f3bbd-fd8d-45c8-8119-57c2a377379d",
                fansUnitedTeamId: "fb:t:81304",
            },
            {
                sportal365_id: "1689",
                uuid: "2e4ace5b-6e6b-477b-a554-3d3c265b027c",
                fansUnitedTeamId: "fb:t:81689",
            },
        ],
    },
    {
        group: "D",
        teams: [
            {
                sportal365_id: "1874",
                uuid: "64ffeae3-e485-4ac3-a86f-98957d8c3692",
                fansUnitedTeamId: "fb:t:81874",
            },
            {
                sportal365_id: "1612",
                uuid: "01db91c1-a088-4912-8c43-04dfdcb2a86a",
                fansUnitedTeamId: "fb:t:81612",
            },
            {
                sportal365_id: "2175",
                uuid: "1bea8f43-da09-479e-9405-76b1fb81a626",
                fansUnitedTeamId: "fb:t:82175",
            },
            {
                sportal365_id: "1845",
                uuid: "ed52eb32-c21c-40a9-8f58-d8eb6dbb5203",
                fansUnitedTeamId: "fb:t:81845",
            },
        ],
    },
    {
        group: "E",
        teams: [
            {
                sportal365_id: "1272",
                uuid: "fd27f9fd-0d40-47bc-aefb-0b4a972ca6e6",
                fansUnitedTeamId: "fb:t:81272",
            },
            {
                sportal365_id: "5048",
                uuid: "74813051-2758-4fd0-9321-e8d97af17b7e",
                fansUnitedTeamId: "fb:t:85048",
            },
            {
                sportal365_id: "2332",
                uuid: "17651e39-ae64-446d-ac4e-9b07b0247718",
                fansUnitedTeamId: "fb:t:82332",
            },
            {
                sportal365_id: "2377",
                uuid: "fd7cd934-3717-414b-8993-f040e4c732c8",
                fansUnitedTeamId: "fb:t:82377",
            },
        ],
    },
    {
        group: "F",
        teams: [
            {
                sportal365_id: "1562",
                uuid: "65a4cc09-41c1-4580-bb2e-3aef24de3646",
                fansUnitedTeamId: "fb:t:81562",
            },
            {
                sportal365_id: "1435",
                uuid: "473d391c-ff45-4cf2-a36f-fdd171cc28b0",
                fansUnitedTeamId: "fb:t:81435",
            },
            {
                sportal365_id: "1788",
                uuid: "964b730c-3708-402b-9cbe-126820ef33ef",
                fansUnitedTeamId: "fb:t:81788",
            },
            {
                sportal365_id: "1828",
                uuid: "e0907f9d-03da-4bc9-9f8c-ae233e59b143",
                fansUnitedTeamId: "fb:t:81828",
            },
        ],
    },
    {
        group: "G",
        teams: [
            {
                sportal365_id: "2206",
                uuid: "b2859799-1743-418d-810c-f41a0e4703fe",
                fansUnitedTeamId: "fb:t:82206",
            },
            {
                sportal365_id: "2387",
                uuid: "067cf849-87d7-4813-bb8c-74e09fe31d70",
                fansUnitedTeamId: "fb:t:82387",
            },
            {
                sportal365_id: "1361",
                uuid: "3fa3da8c-af0b-4541-b715-ef9d589987f3",
                fansUnitedTeamId: "fb:t:81361",
            },
            {
                sportal365_id: "5808",
                uuid: "4e84e417-dbb9-454e-a2ae-8d466bf6d9b0",
                fansUnitedTeamId: "fb:t:85808",
            },
        ],
    },
    {
        group: "H",
        teams: [
            {
                sportal365_id: "1770",
                uuid: "6b08a542-08e7-4c5c-ae1b-012c16f19cfb",
                fansUnitedTeamId: "fb:t:81770",
            },
            {
                sportal365_id: "2272",
                uuid: "22fe101d-5ba2-4fcc-be1a-10d2e7c2970d",
                fansUnitedTeamId: "fb:t:82272",
            },
            {
                sportal365_id: "1676",
                uuid: "dceec7c3-76f2-4d89-8e10-4a299f96190c",
                fansUnitedTeamId: "fb:t:81676",
            },
            {
                sportal365_id: "1903",
                uuid: "e36d253f-32cc-45dc-abaf-51941be9899d",
                fansUnitedTeamId: "fb:t:81903",
            },
        ],
    },
    {
        group: "I",
        teams: [
            {
                sportal365_id: "2434",
                uuid: "ad0849d8-1009-436e-9599-a3634b831c03",
                fansUnitedTeamId: "fb:t:82434",
            },
            {
                sportal365_id: "1715",
                uuid: "5c4d4cb4-1f46-4da8-9044-883a67da08ea",
                fansUnitedTeamId: "fb:t:81715",
            },
            {
                sportal365_id: "1365",
                uuid: "4f42bea7-ab1e-49af-8744-2618c0431c54",
                fansUnitedTeamId: "fb:t:81365",
            },
            {
                sportal365_id: "1588",
                uuid: "027b5b93-94b2-49b0-bee0-744061c9536f",
                fansUnitedTeamId: "fb:t:81588",
            },
        ],
    },
    {
        group: "J",
        teams: [
            {
                sportal365_id: "2153",
                uuid: "43f385a9-17ac-4c7d-8b00-6b2f28b100c2",
                fansUnitedTeamId: "fb:t:82153",
            },
            {
                sportal365_id: "2134",
                uuid: "ddd46536-c48e-4438-8e7b-e99632a103c0",
                fansUnitedTeamId: "fb:t:82134",
            },
            {
                sportal365_id: "2185",
                uuid: "53747460-b421-4334-ad2b-3e180dfef797",
                fansUnitedTeamId: "fb:t:82185",
            },
            {
                sportal365_id: "1454",
                uuid: "4536df97-1fa6-496f-870c-8d26282be5b5",
                fansUnitedTeamId: "fb:t:81454",
            },
        ],
    },
    {
        group: "K",
        teams: [
            {
                sportal365_id: "1651",
                uuid: "975b7dae-b60a-40f5-b160-9d357a875dcd",
                fansUnitedTeamId: "fb:t:81651",
            },
            {
                sportal365_id: "2329",
                uuid: "a92ccac6-2c53-49a5-bac8-7bc134e79725",
                fansUnitedTeamId: "fb:t:82329",
            },
            {
                sportal365_id: "1919",
                uuid: "557694b9-cff7-4ba0-8964-b1d55eb151dd",
                fansUnitedTeamId: "fb:t:81919",
            },
            {
                sportal365_id: "2295",
                uuid: "01331a1a-d3e8-45ea-a491-c557d7835288",
                fansUnitedTeamId: "fb:t:82295",
            },
        ],
    },
    {
        group: "L",
        teams: [
            {
                sportal365_id: "2389",
                uuid: "fcedc975-2bd4-499c-b827-b6fe882b9751",
                fansUnitedTeamId: "fb:t:82389",
            },
            {
                sportal365_id: "2342",
                uuid: "13e3b213-cb4f-4233-84ad-b4533fcad9c0",
                fansUnitedTeamId: "fb:t:82342",
            },
            {
                sportal365_id: "1282",
                uuid: "b36a7f92-ddcf-4d56-9eb5-a259987d2d5f",
                fansUnitedTeamId: "fb:t:81282",
            },
            {
                sportal365_id: "1601",
                uuid: "289f9a35-be1f-4764-8453-638309f5eaee",
                fansUnitedTeamId: "fb:t:81601",
            },
        ],
    },
];
